export default {
  header: 'Willkommen zum Websystem für arbeitspsychologische Tests.',
  header_lisberg:
    'Willkommen zu Psytest‘s Testsystem!',
  content:
    '<p>Wenn Sie ausgebildeter und registrierter Anwender sind: Sie können nach dem Einloggen, verschiedene Testmethoden administrieren und Testergebnisse herunterladen.</p><p>Wenn Sie zu einem Test mit Code-Eingabe eingeladen sind: Klicken Sie auf "Teststart" (nicht auf "Login") und geben Sie den erhaltenen Code ein.</p>',
  content_lisberg:
    'Als Kunde können sie selbständig unsere Tests administrieren und die fertigen Testergebnisse der Kandidaten ausdrucken. Die Tests können via E-mail versendet werden und von Kandidaten zu Hause beantwortet werden. Weitere Informationen über die Testmethoden erhalten Sie bei',
  menu: 'Startseite'
}
